import type { RouterConfig } from '@nuxt/schema'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig> {
  scrollBehavior(to, from, savedPosition) {
    // Sayfa geçişlerinde yukarı kaydır
    if (savedPosition) {
      return savedPosition
    }
    
    // Hash varsa o konuma kaydır
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    
    // Varsayılan olarak yukarı kaydır
    return { top: 0, behavior: 'smooth' }
  }
} 